import {FC} from 'react'

import {Link} from '@/i18n'

import {Button} from '../common/content/Button'
import {ButtonSize, ButtonVariant} from '../common/content/ButtonTypes'

export type HeaderMainButtonProps = {
  text: string
  linkHref?: string
  onClick?: () => void
}

export const HeaderMainButton: FC<HeaderMainButtonProps> = ({text, linkHref, onClick}) => (
  <>
    {linkHref ? (
      <Link href={linkHref} onClick={onClick}>
        <Button type="button" variant={ButtonVariant.primary} size={ButtonSize.medium}>
          {text}
        </Button>
      </Link>
    ) : (
      <div>
        <Button
          type="button"
          variant={ButtonVariant.primary}
          size={ButtonSize.medium}
          onClick={onClick}
        >
          {text}
        </Button>
      </div>
    )}
  </>
)
